import { useInfiniteQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const getUSPDesigns = async ({ queryKey, pageParam = 1 }) => {
  const { limit, search } = queryKey;
  const payload = {
    pageNumber: pageParam,
    limit: limit,
    searchTerm: search,
  };

  const response = await apiClient.post("/api/v1/styles/getAllUSPDesigns", payload);

  if (response.status !== 200) {
    throw new Error("Error fetching order data");
  }

  return {
    data: response.data.data,
    currentPage: response.data.currentPage,
    totalPages: response.data.totalPages,
    totalDesigns: response.data.totalDesigns,
  };
};

export const useUSPDesigns = ({ limit = 20, search }) => {
  return useInfiniteQuery({
    queryKey: ["uspDesigns", { limit, search }],
    queryFn: ({ pageParam = 1 }) => getUSPDesigns({ queryKey: { limit, search }, pageParam }),
    getNextPageParam: (lastPage) => {
      if (lastPage.currentPage < lastPage.totalPages) {
        return lastPage.currentPage + 1;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
